function arrayFirst(arr) {
    for(let i in arr) return arr[i];
}

export {arrayFirst};